import { fromEvent } from 'rxjs/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import { updateInteractionManagementTableData } from '../../redux/modules/reporting/interactionManagement';
import store from '../../redux/store.js';

export function messageObservable() {
  return fromEvent(window, 'message')
    .filter(({ data }) => data.subscription && data.subscription.topic === 'cxengage/reporting/batch-response')
    .map((event) =>
      store.dispatch(
      updateInteractionManagementTableData(event.data.subscription.response)
      )
    );
}

let subscription;
export function messageSubscribe() {
  subscription = messageObservable().subscribe();
}
export function messageUnsubscribe() {
  subscription.unsubscribe();
}
